import type { batchQueryAbWidgetQuery$data } from "scmp-app/queries/__generated__/batchQueryAbWidgetQuery.graphql";

type Edge = NonNullable<batchQueryAbWidgetQuery$data["widget1"]>["edges"][number];

export const reorderEdgesByEntityIds = (
  edges: null | readonly Edge[] | undefined,
  entityIds: string[],
): Edge[] => {
  if (!edges) return [];

  const edgeMap = new Map<string, Edge>();
  for (const edge of edges) {
    if (edge?.node?.entityId) {
      edgeMap.set(edge.node.entityId, edge);
    }
  }

  const reordered: Edge[] = [];
  for (const entityId of entityIds) {
    const edge = edgeMap.get(entityId);
    if (edge) {
      reordered.push(edge);
      edgeMap.delete(entityId);
    }
  }

  for (const edge of edges) {
    if (edge?.node?.entityId && edgeMap.has(edge.node.entityId)) {
      reordered.push(edge);
    }
  }

  return reordered;
};
